module.exports = __webpack_public_path__ + "static/media/ic_gov_meit.c59e1378.svg";